import { _$get } from "./request/index";
interface paramsType {
	userId: string;
}
const deviceListApi = async (params: paramsType): Promise<objectType | null> => {
	try {
		const result = await _$get({
			url: "device/list",
			params: params
		});
		return result;
	} catch (e) {
		return null;
	}
};

export default deviceListApi;
